import jsPDF from 'jspdf'

export const createThermalReceiptPDF = (canvas, isPharmacyCopy = false) => {
    // Use A4 format for pharmacy copy, thermal format for regular receipts
    const format = isPharmacyCopy ? 'a4' : [80, 210]
    const pdfWidth = isPharmacyCopy ? 210 : 80
    const pdfHeight = isPharmacyCopy ? 297 : 210

    const pdf = new jsPDF({
        orientation: 'portrait',
        unit: 'mm',
        format: format
    })
    const margin = 0
    const usableWidth = pdfWidth - margin * 2
    const usableHeight = pdfHeight - margin * 2

    const canvasWidthMM = (canvas.width * 25.4) / 96
    const canvasHeightMM = (canvas.height * 25.4) / 96

    const widthScale = usableWidth / canvasWidthMM
    const scaledHeight = canvasHeightMM * widthScale

    const totalPages = Math.ceil(scaledHeight / usableHeight)

    for (let i = 0; i < totalPages; i++) {
        if (i > 0) {
            pdf.addPage([80, 210])
        }

        const sourceYPixels = ((i * usableHeight) / widthScale) * (96 / 25.4)
        const sourceHeightPixels = Math.min(
            (usableHeight / widthScale) * (96 / 25.4),
            canvas.height - sourceYPixels
        )

        const pageCanvas = document.createElement('canvas')
        const pageContext = pageCanvas.getContext('2d')

        pageCanvas.width = canvas.width
        pageCanvas.height = Math.ceil(sourceHeightPixels)

        pageContext.fillStyle = '#ffffff'
        pageContext.fillRect(0, 0, pageCanvas.width, pageCanvas.height)

        pageContext.drawImage(
            canvas,
            0,
            sourceYPixels,
            canvas.width,
            sourceHeightPixels,
            0,
            0,
            canvas.width,
            sourceHeightPixels
        )

        const pageDataURL = pageCanvas.toDataURL('image/png', 1.0)

        const pageHeightMM = Math.min(
            usableHeight,
            scaledHeight - i * usableHeight
        )

        pdf.addImage(pageDataURL, 'PNG', 0, 0, usableWidth, pageHeightMM)

        if (totalPages > 1) {
            pdf.setFontSize(8)
            pdf.setTextColor(128, 128, 128)
            pdf.text(
                `Page ${i + 1} of ${totalPages}`,
                pdfWidth / 2,
                pdfHeight - 1,
                { align: 'center' }
            )
        }
    }

    const filename = isPharmacyCopy ? 'order.pdf' : 'thermal_receipt.pdf'
    pdf.save(filename)
}

export const printThermalReceipt = (canvas, isPharmacyCopy = false) => {
    try {
        const dataURL = canvas.toDataURL('image/png', 1.0)
        const windowWidth = isPharmacyCopy ? 800 : 400
        const windowHeight = isPharmacyCopy ? 1000 : 800
        const printWindow = window.open('', '_blank', `width=${windowWidth},height=${windowHeight}`)

        if (!printWindow) {
            alert('Please allow popups for this site to enable printing')
            return
        }

        const pageSize = isPharmacyCopy ? 'A4' : '80mm auto'
        const imgMaxWidth = isPharmacyCopy ? '100%' : '100%'

        const htmlContent = `
            <!DOCTYPE html>
            <html>
            <head>
                <title>${isPharmacyCopy ? 'Print Invoice' : 'Print Thermal Receipt'}</title>
                <link rel="preconnect" href="https://fonts.googleapis.com">
                <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
                <link href="https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap" rel="stylesheet">
                <link href="https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500;700&display=swap" rel="stylesheet">
                <style>
                    * {
                        margin: 0 !important;
                        padding: 0 !important;
                        box-sizing: border-box;
                    }
                    html {
                        margin: 0 !important;
                        padding: 0 !important;
                    }
                    body {
                        background: white;
                        margin: 0 !important;
                        padding: ${isPharmacyCopy ? '10px' : '0'} !important;
                        font-family: 'Inter', 'Roboto', 'Arial', sans-serif;
                        font-feature-settings: 'tnum' 1, 'kern' 1;
                        -webkit-font-smoothing: antialiased;
                        -moz-osx-font-smoothing: grayscale;
                        text-rendering: optimizeLegibility;
                    }
                    img {
                        max-width: ${imgMaxWidth};
                        height: auto;
                        display: block;
                        margin: 0 auto !important;
                        padding: 0 !important;
                    }
                    @media print {
                        @page {
                            size: ${pageSize};
                            margin: ${isPharmacyCopy ? '10mm' : '0'} !important;
                        }
                        * {
                            margin: 0 !important;
                            padding: 0 !important;
                        }
                        html {
                            margin: 0 !important;
                            padding: 0 !important;
                        }
                        body {
                            margin: 0 !important;
                            padding: 0 !important;
                            background: white;
                            font-family: 'Inter', 'Roboto', 'Arial', sans-serif;
                            font-feature-settings: 'tnum' 1, 'kern' 1;
                            -webkit-font-smoothing: antialiased;
                            -moz-osx-font-smoothing: grayscale;
                            text-rendering: optimizeLegibility;
                        }
                        img {
                            max-width: 100%;
                            height: auto;
                            display: block;
                            margin: 0 auto !important;
                            padding: 0 !important;
                            page-break-inside: avoid;
                        }
                    }
                </style>
            </head>
            <body>
                <img src="${dataURL}" alt="${isPharmacyCopy ? 'Invoice' : 'Thermal Receipt'}" onload="window.print(); setTimeout(() => window.close(), 1500);" />
            </body>
            </html>
        `

        printWindow.document.write(htmlContent)
        printWindow.document.close()

        setTimeout(() => {
            try {
                printWindow.print()
                setTimeout(() => printWindow.close(), 1500)
            } catch (e) {
                createThermalReceiptPDF(canvas, isPharmacyCopy)
            }
        }, 1000)
    } catch (error) {
        console.error('Print error:', error)
        alert('Unable to print directly. Creating PDF instead.')
        createThermalReceiptPDF(canvas, isPharmacyCopy)
    }
}
